import "./summaryStyle.css"

export const Summary = () => {
  return (
    <section className="py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Logo and Image */}
          <div className="text-center">
            <div className="mb-6">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">からあげ専門店</h1>
              <div className="mb-4">
                <div className="text-4xl md:text-6xl font-bold text-orange-600 mb-2">幸の鶏</div>
                <div className="text-lg md:text-xl text-gray-600">〜コウノトリ〜</div>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="/images/front202410.jpg?height=300&width=400"
                alt="幸の鶏 店舗外観"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          </div>

          {/* Store Information */}
          <div className="space-y-6">
            {/* Highlights */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 text-center">
                <div className="text-green-700 font-semibold">国産鶏を使用</div>
              </div>
              <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4 text-center">
                <div className="text-blue-700 font-semibold">電話注文承ります</div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-white rounded-lg shadow-lg p-6 space-y-4">
              <div className="flex items-center gap-3">
                <svg
                  className="w-5 h-5 text-orange-600 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <div>
                  <span className="font-semibold">電話: </span>
                  <a href="tel:0995-47-5013" className="text-orange-600 hover:text-orange-700 font-bold text-lg">
                    0995-47-5013
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <div>
                  <div className="font-semibold">住所:</div>
                  <div className="text-gray-700">鹿児島県霧島市国分中央1-7-30</div>
                  <div className="text-sm text-gray-600">国分中央病院前　ブックオフ隣</div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <svg
                  className="w-5 h-5 text-orange-600 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
                <div className="text-gray-700">店舗横 駐車場2台あり</div>
              </div>

              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12,6 12,12 16,14"></polyline>
                </svg>
                <div>
                  <div className="font-semibold">営業時間:</div>
                  <div className="text-gray-700">11:00 〜 14:00<br/>16:00 〜 19:30</div>
                  <div className="text-sm text-gray-600">電話のラストオーダーは19:00まで</div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <svg
                  className="w-5 h-5 text-orange-600 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <div>
                  <span className="font-semibold">定休日: </span>
                  <span className="text-gray-700">毎週火曜日、第2・3水曜日</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
